import React from 'react'

interface WheelCursorShadowProps {
  width: number
  height: number
  color: string
}

export default class WheelCursorShadow extends React.PureComponent<WheelCursorShadowProps> {
  private svg: SVGElement | null = null

  setDeg(deg: number) {
    if (this.svg) {
      this.svg.style.transform = `rotateZ(${deg}deg)`
    }
  }

  render() {
    return (
      <svg
        ref={(ref) => (this.svg = ref)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 57.32 38.86"
        width={this.props.width}
        height={this.props.height}
      >
        <defs>
          <style>{`
          .cls-1{fill:${this.props.color};opacity:0.5;}
        `}</style>
        </defs>
        <g id="Layer_2" data-name="Layer 2">
          <g id="CURSEUR">
            <path
              className="cls-1"
              d="M54.06,38.86Q56.36,19.51,57.32,0L0,18v3.68Z"
            />
          </g>
        </g>
      </svg>
    )
  }
}
